import { render, staticRenderFns } from "./ChatMain.vue?vue&type=template&id=bbf41494&scoped=true&"
import script from "./ChatMain.vue?vue&type=script&lang=js&"
export * from "./ChatMain.vue?vue&type=script&lang=js&"
import style0 from "./ChatMain.vue?vue&type=style&index=0&id=bbf41494&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf41494",
  null
  
)

export default component.exports